(function () {
  if (window.__MP_DRAWER_LOADED__) return;
  window.__MP_DRAWER_LOADED__ = true;

  const cfg = window.__MATCH_PRICE_DATA__ || {};
  const apiBase = cfg.api_base || "https://match-price.medisa.au";

  const ctx = {
    storeDomain: cfg.store_domain || "",
    productTitle: cfg.product_title || "",
    productHandle: cfg.product_handle || "",
    productId: cfg.product_id || "",
    selectedVariantId: cfg.selected_variant_id || "",
    productUrl: window.location.href,
    customerEmail: cfg.customer_email || "",
  };

  const style = document.createElement("style");
  style.textContent = `
    .mp-overlay{position:fixed;inset:0;background:rgba(0,0,0,.35);opacity:0;pointer-events:none;transition:opacity .18s ease;z-index:999998;}
    .mp-overlay.open{opacity:1;pointer-events:auto;}
    .mp-drawer{position:fixed;top:0;right:0;height:100vh;width:min(440px,92vw);background:#fff;transform:translateX(100%);transition:transform .22s ease;z-index:999999;box-shadow:-10px 0 30px rgba(0,0,0,.2);display:flex;flex-direction:column;}
    .mp-drawer.open{transform:translateX(0);}
    .mp-head{padding:18px;border-bottom:1px solid rgba(0,0,0,.08);display:flex;justify-content:space-between;gap:12px;}
    .mp-title{font-size:18px;font-weight:800;margin:0;}
    .mp-help{font-size:12px;color:rgba(0,0,0,.6);margin:6px 0 0;}
    .mp-close{background:transparent;border:0;cursor:pointer;font-size:28px;line-height:1;}
    .mp-body{padding:16px 18px;overflow:auto;}
    .mp-label{font-size:13px;font-weight:700;margin:14px 0 6px;display:block;}
    .mp-input,.mp-textarea{width:100%;border:1px solid rgba(0,0,0,.15);border-radius:10px;padding:12px;font-size:14px;box-sizing:border-box;}
    .mp-textarea{min-height:110px;resize:vertical;}
    .mp-actions{padding:14px 18px 18px;border-top:1px solid rgba(0,0,0,.08);}
    .mp-submit{width:100%;background:#111;color:#fff;border:0;border-radius:10px;padding:14px 16px;font-weight:800;cursor:pointer;}
    .mp-submit:disabled{opacity:.6;cursor:not-allowed;}
    .mp-msg{margin-top:10px;font-size:13px;}
  `;
  document.head.appendChild(style);

  const root = document.createElement("div");
  root.id = "mp-drawer-root";
  root.innerHTML = `
    <div class="mp-overlay" id="mp-overlay"></div>

    <aside class="mp-drawer" id="mp-drawer" role="dialog" aria-modal="true" aria-label="Match Price">
      <div class="mp-head">
        <div>
          <p class="mp-title">Match Price</p>
          <p class="mp-help">${escapeHtml(ctx.productTitle)}</p>
        </div>
        <button class="mp-close" id="mp-close" type="button" aria-label="Close">×</button>
      </div>

      <div class="mp-body">
        <label class="mp-label">Competitor product link</label>
        <input class="mp-input" id="mp-competitor-url" type="url" placeholder="https://..." />

        <label class="mp-label">Your email</label>
        <input class="mp-input" id="mp-email" type="email" placeholder="you@email.com" value="${escapeHtml(ctx.customerEmail)}" />

        <label class="mp-label">Competitor price (optional)</label>
        <input class="mp-input" id="mp-price" type="text" placeholder="e.g. 89.90" />

        <label class="mp-label">Notes</label>
        <textarea class="mp-textarea" id="mp-notes" placeholder="Any extra details..."></textarea>

        <div class="mp-msg" id="mp-msg"></div>
      </div>

      <div class="mp-actions">
        <button class="mp-submit" id="mp-submit" type="button">Submit request</button>
      </div>
    </aside>
  `;
  document.body.appendChild(root);

  const overlay = document.getElementById("mp-overlay");
  const drawer = document.getElementById("mp-drawer");
  const closeBtn = document.getElementById("mp-close");
  const submitBtn = document.getElementById("mp-submit");
  const msg = document.getElementById("mp-msg");

  function open() {
    overlay.classList.add("open");
    drawer.classList.add("open");
  }

  function close() {
    overlay.classList.remove("open");
    drawer.classList.remove("open");
    msg.textContent = "";
    msg.style.color = "#111";
  }

  document.addEventListener("MP_OPEN", open);
  overlay.addEventListener("click", close);
  closeBtn.addEventListener("click", close);

  window.addEventListener("keydown", function (e) {
    if (e.key === "Escape") close();
  });

  submitBtn.addEventListener("click", async function () {
    const competitorUrl = document.getElementById("mp-competitor-url").value.trim();
    const customerEmail = document.getElementById("mp-email").value.trim();
    const competitorPrice = document.getElementById("mp-price").value.trim();
    const notes = document.getElementById("mp-notes").value.trim();

    msg.textContent = "";
    msg.style.color = "#111";

    if (!competitorUrl) {
      msg.style.color = "#b00020";
      msg.textContent = "Please enter competitor product link.";
      return;
    }

    if (!customerEmail) {
      msg.style.color = "#b00020";
      msg.textContent = "Please enter your email.";
      return;
    }

    submitBtn.disabled = true;
    submitBtn.textContent = "Sending...";

    try {
      const res = await fetch(`${apiBase}/api/match-price`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          storeDomain: ctx.storeDomain,
          productTitle: ctx.productTitle,
          productHandle: ctx.productHandle,
          productId: ctx.productId,
          selectedVariantId: ctx.selectedVariantId,
          productUrl: ctx.productUrl,
          competitorUrl,
          customerEmail,
          competitorPrice,
          notes,
        }),
      });

      const json = await res.json().catch(function () {
        return {};
      });

      if (!res.ok || json.ok === false) throw new Error("REQUEST_FAILED");

      msg.style.color = "#0a7a27";
      msg.textContent = "Request sent. We’ll review and contact you soon.";

      document.getElementById("mp-competitor-url").value = "";
      document.getElementById("mp-price").value = "";
      document.getElementById("mp-notes").value = "";
    } catch (e) {
      msg.style.color = "#b00020";
      msg.textContent = "Could not send request. Please try again.";
    } finally {
      submitBtn.disabled = false;
      submitBtn.textContent = "Submit request";
    }
  });

  function escapeHtml(s) {
    return String(s || "")
      .replaceAll("&", "&amp;")
      .replaceAll("<", "&lt;")
      .replaceAll(">", "&gt;")
      .replaceAll('"', "&quot;")
      .replaceAll("'", "&#039;");
  }

  document.addEventListener("click", function (e) {
    const btn = e.target.closest("#match-price-btn, .md-match-price-btn, [data-match-price-open]");
    if (!btn) return;

    e.preventDefault();
    document.dispatchEvent(new CustomEvent("MP_OPEN"));
  });
})();